import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSnackbar } from "notistack";
import { useHistory, Link } from "react-router-dom";

export function ForgotPaswword() {
  const { register, handleSubmit, errors, setValue } = useForm();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [resetMethod, setResetMethod] = useState("email");
  const [userType, setUserType] = useState("seeker");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setValue("type", "seeker");
  }, []);

  const onSubmit = async (value) => {
    setLoading(true);
    setSuccessMsg("");
    try {
      const res = await axios.post("api/reset_user_password", {
        ...value,
        type: userType,
        reset: resetMethod,
      });
      enqueueSnackbar(res.data.message, { variant: res.data.status });
      if (res.data.status === "success") {
        setSuccessMsg(
          resetMethod === "email"
            ? `Reset link sent to ${value.email}. Check your inbox.`
            : `OTP sent to ${value.mobile}. Valid for 10 minutes.`
        );
        window.localStorage.setItem("rp_mobile", value.mobile || "");
        window.localStorage.setItem("rp_email", value.email || "");
        window.localStorage.setItem("rp_type", userType);
        setTimeout(() => history.push("/reset_password"), 1800);
      }
    } catch (e) {
      enqueueSnackbar("Something went wrong. Please try again.", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="section-full p-t60 p-b0 bg-white">
    
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-12">
            <figure className="account-image">
              <img src="/portal/images/login.png" alt="Forgot password illustration" />
            </figure>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-12">
            <div className="twm-log-reg-form-wrap">

              <h2 className="wt-title">Forgot Password ?</h2>
              <p className="twm-log-reg-subtitle">
                Choose your account type and how you'd like to receive reset instructions.
              </p>

              {/* ── Jobseeker / Employer tabs ── */}
              <div className="radio_tabs">
                <ul>
                  <li
                    className={userType === "seeker" ? "active-tab" : ""}
                    onClick={() => setUserType("seeker")}
                    style={{ cursor: "pointer" }}
                  >
                    <span className={userType === "seeker" ? "tab-dot active-dot" : "tab-dot"}></span>
                    Jobseeker
                  </li>
                  <li
                    className={userType === "employer" ? "active-tab" : ""}
                    onClick={() => setUserType("employer")}
                    style={{ cursor: "pointer" }}
                  >
                    <span className={userType === "employer" ? "tab-dot active-dot" : "tab-dot"}></span>
                    Employer
                  </li>
                </ul>
              </div>

              <p className="fp-reset-info">
                Please choose either email or mobile to receive the instructions to reset your password.
              </p>

              {/* ── Email / SMS method tabs ── */}
              <div className="radio_tabs fp-method-tabs">
                <ul>
                  <li
                    className={resetMethod === "email" ? "active-tab" : ""}
                    onClick={() => setResetMethod("email")}
                    style={{ cursor: "pointer" }}
                  >
                    <span className={resetMethod === "email" ? "tab-dot active-dot" : "tab-dot"}></span>
                    <i className="ri-mail-line"></i> Email
                  </li>
                  <li
                    className={resetMethod === "sms" ? "active-tab" : ""}
                    onClick={() => setResetMethod("sms")}
                    style={{ cursor: "pointer" }}
                  >
                    <span className={resetMethod === "sms" ? "tab-dot active-dot" : "tab-dot"}></span>
                    <i className="ri-smartphone-line"></i> Mobile
                  </li>
                </ul>
              </div>

              <form onSubmit={handleSubmit(onSubmit)}>
                <input type="hidden" name="type" ref={register()} value={userType} />

                {/* Email field */}
                {resetMethod === "email" && (
                  <div className="form-group mb-3">
                    <label className="twm-field-label">
                      Email Address <span className="sf-required">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Enter your registered email"
                      className={`form-control ${errors.email ? "is-invalid" : ""}`}
                      ref={register({
                        required: "Email address is required",
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Please enter a valid email address",
                        },
                      })}
                    />
                    {errors.email && (
                      <div className="text-danger sf-field-error">{errors.email.message}</div>
                    )}
                  </div>
                )}

                {/* Mobile field */}
                {resetMethod === "sms" && (
                  <div className="form-group mb-3">
                    <label className="twm-field-label">
                      Mobile Number <span className="sf-required">*</span>
                    </label>
                    <input
                      type="number"
                      name="mobile"
                      placeholder="Enter your 10-digit mobile number"
                      className={`form-control ${errors.mobile ? "is-invalid" : ""}`}
                      ref={register({
                        required: "Mobile number is required",
                        minLength: { value: 10, message: "Must be exactly 10 digits" },
                        maxLength: { value: 10, message: "Must be exactly 10 digits" },
                      })}
                    />
                    {errors.mobile && (
                      <div className="text-danger sf-field-error">{errors.mobile.message}</div>
                    )}
                  </div>
                )}

                {/* Success message */}
                {successMsg && (
                  <div className="fp-success-banner">
                    <i className="ri-checkbox-circle-line"></i>
                    <span>{successMsg}</span>
                  </div>
                )}

                <button type="submit" className="site-button" disabled={loading}>
                  {loading ? "Sending…" : "Send Reset Instructions"}
                </button>
              </form>

              <p className="twm-new-register" style={{ marginTop: "18px" }}>
                Remember your password ?{" "}
                <Link to="/login" className="site-text-primary">Back to Login</Link>
              </p>

            </div>
          </div>
        </div>
      
    </div>
  );
}

export default ForgotPaswword;
